import { render, staticRenderFns } from "./add-role.vue?vue&type=template&id=ebb13704&scoped=true"
import script from "./add-role.ts?vue&type=script&lang=ts&external"
export * from "./add-role.ts?vue&type=script&lang=ts&external"
import style0 from "./add-role.scoped.scss?vue&type=style&index=0&id=ebb13704&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebb13704",
  null
  
)

export default component.exports